// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadInstructionsStyles } from "@awc/App/Widgets/OrderUpload/OrderUploadInstructions";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

orderUploadInstructionsStyles.wrapper = {
    css: css`
        ol,
        li,
        ul,
        ol > ul {
            margin: 0;
        }

        &&& ol,
        &&& ul {
            padding: 0 0 0 20px;
        }
    `,
};

orderUploadInstructionsStyles.linkStyle = {
    typographyProps: { size: fontConfig.fontSize.regular },
};

orderUploadInstructionsStyles.lastListItem = {
    css: css`
        font-weight: ${fontConfig.weight.bold};
        color: ${color("secondary")};
        font-style: italic;
    `,
};
